var map = {
	"./atom.png": 407,
	"./browser.png": 964,
	"./chat.png": 695,
	"./css-3.png": 383,
	"./gear.png": 651,
	"./github.png": 343,
	"./gmail.png": 578,
	"./html.png": 867,
	"./js.png": 820,
	"./linkedin.png": 518,
	"./logo.png": 427,
	"./logo1.png": 461,
	"./sahil.jpeg": 106,
	"./tools.png": 82
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;